import type { RouteRecordRaw } from 'vue-router'
import { UserRole } from '@/types/router'

export const userIdentityRoutes: RouteRecordRaw[] = [
  // 设计师认证 - 注册页面
  {
    path: 'designer/registration',
    name: 'DesignerRegistration',
    component: () => import('@/views/userCenter/DesignerRegistration.vue'),
    meta: {
      title: '设计师注册',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'EditPen',
      order: 5,
      breadcrumb: true,
      cache: false,
      category: 'identity',
      subcategory: 'designer',
      description: '3步简化注册流程，成为专业设计师',
    },
  },

  // 项目经验管理页面
  {
    path: 'project-experience',
    name: 'ProjectExperience',
    component: () => import('@/views/userCenter/ProjectExperience.vue'),
    meta: {
      title: '项目经验',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'Edit',
      order: 6,
      breadcrumb: true,
      cache: false,
      category: 'identity',
      isStatusDriven: true,
      hasTabPages: true,
      description: '管理个人或企业项目经验',
    },
  },

  // 资质证书管理
  {
    path: 'qualifications',
    name: 'UserQualifications',
    component: () => import('@/views/userCenter/Qualifications.vue'),
    meta: {
      title: '资质证书',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'Document',
      order: 7,
      breadcrumb: true,
      cache: false,
      category: 'identity',
      description: '管理个人或企业的资质证书和奖项',
    },
  },

  // 服务商认证 - 注册页面
  {
    path: 'provider/registration',
    name: 'ProviderRegistration',
    component: () => import('@/views/userCenter/ServiceProviderRegistration.vue'),
    meta: {
      title: '服务商注册',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'OfficeBuilding',
      order: 9,
      breadcrumb: true,
      cache: false,
      category: 'identity',
      subcategory: 'provider',
      description: '6步企业注册流程，加入服务商网络',
    },
  },

  // 兼容性路由 - 重定向到新的中心页面
  {
    path: 'designer',
    redirect: '/user/project-experience',
  },
  {
    path: 'provider',
    redirect: '/user/project-experience',
  },
]
